import { RestApiServerError } from './RestApiServerError';

export type GeneralErrorResponseData = { detail?: string };

export class RestApiGeneralError extends RestApiServerError {
  constructor(response: { data: GeneralErrorResponseData; status?: number }) {
    super([response.data?.detail ?? 'UNKNOWN_ERROR'], [], response.status);
  }
}
